import { createAsyncThunk } from '@reduxjs/toolkit';
import { Hexabase } from 'hexabase-sdk';
import { userService } from 'services';
import { LoginError, LoginRequest, LoginResponse, ThunkAPI } from 'types';

export const login = createAsyncThunk<LoginResponse, LoginRequest, ThunkAPI<LoginError>>(
  'LoginPage/login',
  async (params, { rejectWithValue }) => {
    try {
      const { token } = await userService.login(params);
      window.localStorage.setItem('token', token);
      return {
        message: 'Login successfull',
      };
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

export const getWorkspace = createAsyncThunk('loginPage/getWorkSpace', async () => {
  try {
    const resp = await Hexabase.workspaces().getWorkspacesAsync().ResultAsync<{
      current_workspace_id: string;
      workspaces: Array<any>;
    }>();
    let applications: Array<any> = await Hexabase.applications()
      .getApplications({ workspace_id: resp.workspaces[0].workspace_id })
      .ResultAsync();
    return {
      currentWorkSpaceId: resp.current_workspace_id,
      currentApplicationId: applications[0].application_id,
    };
  } catch (e) {
    console.log(e);
  }
});
